import { render, staticRenderFns } from "./addAttrSpec.vue?vue&type=template&id=7fc8dec0"
import script from "./addAttrSpec.vue?vue&type=script&lang=js"
export * from "./addAttrSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports